
import Vue from 'vue'

export default Vue.extend({
    name: 'Pricing',
    components: {
    },
    computed: {
        typeFormUrl() {
            const url = new URL(process.env.VUE_APP_CONTACT_US_TYPEFORM || 'https://ws.namecard.ai/intro?src=home');
            url.searchParams.set('src', 'home_pricing');
            return url.href;
        },
        namecardWSUrl() {
            return process.env.VUE_APP_NAMECARD_WORKSPACE_URL;
        }
    },
    data(){
        return{
        }
    },
    methods: {
    },
    mounted() {
    }
})
